<template>
  <div id="app">
    <my-header/>
    <router-view/>
<!--    <my-footer/>-->
  </div>
</template>

<script>
import myHeader from '@/components/header'
import myFooter from '@/components/footer'
export default {
  name: 'App',
  components: {
    myHeader,
    myFooter
  }
}
</script>

<style lang='stylus'>
html,body{
  margin: 0;
  padding:0
}
#app{
  min-width:1000px;
  min-height 100vh;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f7f8fa;
  display flex;
  flex-direction column;
  justify-content space-between;
}
</style>



// WEBPACK FOOTER //
// src/App.vue